// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .form-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: var(--spacing-sm);
    margin-bottom: var(--spacing-lg);
  }
  .data {
    font-weight: 800;
    color: #767676;
  }
  .label_col {
    margin-right: 10px;
  }
  

  .controls-container {
    display: flex;
    align-items: center;
    gap: var(--spacing-xl);
    margin-bottom: var(--spacing-lg);
    padding: var(--spacing-md) var(--spacing-xl);
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: var(--shadow-sm);
  }
  
  
  .radio-group {
    display: flex;
    gap: var(--spacing-lg);
    flex-shrink: 0;
  }
  
  .radio-group label {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    margin: 0;
    cursor: pointer;
    font-weight: 500;
  }
  
  .radio-group input[type="radio"] {
    width: auto;
    margin: 0;
  }
  
 
  .search-field {
    position: relative;
    width: 300px;
    flex-shrink: 0;
  }
  
  .search-field input {
    width: 100%;
    padding: var(--spacing-sm) var(--spacing-xl) var(--spacing-sm) var(--spacing-md);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 0.9rem;
  }
  
  .search-field i {
    position: absolute;
    right: var(--spacing-sm);
    top: 50%;
    transform: translateY(-50%);
    color: var(--secondary-grey);
    pointer-events: none;
  }
  
  
  .date-picker {
    flex-shrink: 0;
  }
  
  .date-picker input {
    padding: var(--spacing-sm);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 0.9rem;
    color: #767676;
    width: 150px;
    cursor: pointer;
  }
  
 
  .search-container,
  .date-range {
    display: none;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-md);
    margin-top: var(--spacing-xl);
  }
  .tabs-container .tab  {
   
    background-color: #959595;
    
    color: #fff;
    border: none;
    padding: 8px;
    border-radius: 8px;
    margin-right: 10px;
  }
  .tab.active {
   
    background-color: var(--primary-yellow);
    color: var(--primary-grey);
    font-weight: 500;
  } 
  .group_div {
    display: flex;
    justify-content: space-between;
  }
  .floating-label-group {
    position: relative;
    margin-top: var(--spacing-md); 
  }
  
  .floating-label-group input {
    width: 100%;
    padding: var(--spacing-sm); 
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 1rem;
   
    background-color: var(--white); 
  }
  
  .floating-label-group label {
    position: absolute;
    left: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    
    color: #767676;
    background-color: var(--white); 
    padding: 0 var(--spacing-xs); 
    transition: all 0.2s ease-out;
    pointer-events: none; 
    font-size: 14px;
  }
  
  
  .floating-label-group input:focus + label,
  .floating-label-group input:not(:placeholder-shown) + label {
    top: 0; 
    transform: translateY(-50%) scale(0.85); 
    color: var(--primary-grey); 
    font-weight: 500;
  }
  
  
  .floating-label-group input:focus {
    outline: none;
    border-color: var(--primary-yellow); 
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2); 
  }
  
 
  .floating-label-group input::placeholder {
    color: transparent; 
  }
  .form-group {
    margin-bottom: 0; 
  }
  
  select {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.7rem center;
    background-size: 1em;
  }
  
  
  .form-group.error input,
  .form-group.error select {
    border-color: var(--error-red);
  }
  
  .form-group.error .error-message {
    color: var(--error-red);
    font-size: 0.875rem;
    margin-top: var(--spacing-xs);
  }
  
  
  .form-group.success input,
  .form-group.success select {
    border-color: var(--success-green);
  }

  .main_container {
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  .group_div {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 10px;
    margin-bottom: 0;
  }
  .inp_div {
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 0;
  }
  .blue_primary {
    background-color: #0056B3;
    color: #fff;
    margin-left: 10px;
  } */



  .attachment_text {
  display: inline-block;
  max-width: 200px; /* or whatever width suits your layout */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  }

  @media(max-width:768px) {
.yellow_apply {
  display: flex;
  justify-content: center;
}
.yellow_apply .yellow_btn_1 {
  width: 30%;
  padding:0
}
  }
`, "",{"version":3,"sources":["webpack://./src/pages/StaffManagement/TrackVehicle1/TrackVehicle.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAyNK;;;;EAIH;EACA,qBAAqB;EACrB,gBAAgB,EAAE,wCAAwC;EAC1D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB;;EAEA;AACF;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV;AACF;EACE","sourcesContent":["/* .form-row {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: var(--spacing-sm);\r\n    margin-bottom: var(--spacing-lg);\r\n  }\r\n  .data {\r\n    font-weight: 800;\r\n    color: #767676;\r\n  }\r\n  .label_col {\r\n    margin-right: 10px;\r\n  }\r\n  \r\n\r\n  .controls-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-xl);\r\n    margin-bottom: var(--spacing-lg);\r\n    padding: var(--spacing-md) var(--spacing-xl);\r\n    background-color: var(--white);\r\n    border-radius: 4px;\r\n    box-shadow: var(--shadow-sm);\r\n  }\r\n  \r\n  \r\n  .radio-group {\r\n    display: flex;\r\n    gap: var(--spacing-lg);\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .radio-group label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-xs);\r\n    margin: 0;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .radio-group input[type=\"radio\"] {\r\n    width: auto;\r\n    margin: 0;\r\n  }\r\n  \r\n \r\n  .search-field {\r\n    position: relative;\r\n    width: 300px;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .search-field input {\r\n    width: 100%;\r\n    padding: var(--spacing-sm) var(--spacing-xl) var(--spacing-sm) var(--spacing-md);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .search-field i {\r\n    position: absolute;\r\n    right: var(--spacing-sm);\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: var(--secondary-grey);\r\n    pointer-events: none;\r\n  }\r\n  \r\n  \r\n  .date-picker {\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .date-picker input {\r\n    padding: var(--spacing-sm);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 0.9rem;\r\n    color: #767676;\r\n    width: 150px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n \r\n  .search-container,\r\n  .date-range {\r\n    display: none;\r\n  }\r\n  \r\n  .form-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: var(--spacing-md);\r\n    margin-top: var(--spacing-xl);\r\n  }\r\n  .tabs-container .tab  {\r\n   \r\n    background-color: #959595;\r\n    \r\n    color: #fff;\r\n    border: none;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n    margin-right: 10px;\r\n  }\r\n  .tab.active {\r\n   \r\n    background-color: var(--primary-yellow);\r\n    color: var(--primary-grey);\r\n    font-weight: 500;\r\n  } \r\n  .group_div {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .floating-label-group {\r\n    position: relative;\r\n    margin-top: var(--spacing-md); \r\n  }\r\n  \r\n  .floating-label-group input {\r\n    width: 100%;\r\n    padding: var(--spacing-sm); \r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n   \r\n    background-color: var(--white); \r\n  }\r\n  \r\n  .floating-label-group label {\r\n    position: absolute;\r\n    left: var(--spacing-md);\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    \r\n    color: #767676;\r\n    background-color: var(--white); \r\n    padding: 0 var(--spacing-xs); \r\n    transition: all 0.2s ease-out;\r\n    pointer-events: none; \r\n    font-size: 14px;\r\n  }\r\n  \r\n  \r\n  .floating-label-group input:focus + label,\r\n  .floating-label-group input:not(:placeholder-shown) + label {\r\n    top: 0; \r\n    transform: translateY(-50%) scale(0.85); \r\n    color: var(--primary-grey); \r\n    font-weight: 500;\r\n  }\r\n  \r\n  \r\n  .floating-label-group input:focus {\r\n    outline: none;\r\n    border-color: var(--primary-yellow); \r\n    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2); \r\n  }\r\n  \r\n \r\n  .floating-label-group input::placeholder {\r\n    color: transparent; \r\n  }\r\n  .form-group {\r\n    margin-bottom: 0; \r\n  }\r\n  \r\n  select {\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 0.7rem center;\r\n    background-size: 1em;\r\n  }\r\n  \r\n  \r\n  .form-group.error input,\r\n  .form-group.error select {\r\n    border-color: var(--error-red);\r\n  }\r\n  \r\n  .form-group.error .error-message {\r\n    color: var(--error-red);\r\n    font-size: 0.875rem;\r\n    margin-top: var(--spacing-xs);\r\n  }\r\n  \r\n  \r\n  .form-group.success input,\r\n  .form-group.success select {\r\n    border-color: var(--success-green);\r\n  }\r\n\r\n  .main_container {\r\n    border: 1px solid #e7e7e7;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .group_div {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    padding-top: 10px;\r\n    margin-bottom: 0;\r\n  }\r\n  .inp_div {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    margin-bottom: 0;\r\n  }\r\n  .blue_primary {\r\n    background-color: #0056B3;\r\n    color: #fff;\r\n    margin-left: 10px;\r\n  } */\r\n\r\n\r\n\r\n  .attachment_text {\r\n  display: inline-block;\r\n  max-width: 200px; /* or whatever width suits your layout */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  vertical-align: bottom;\r\n  }\r\n\r\n  @media(max-width:768px) {\r\n.yellow_apply {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.yellow_apply .yellow_btn_1 {\r\n  width: 30%;\r\n  padding:0\r\n}\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
